import { render, staticRenderFns } from "./ReferralItem.vue?vue&type=template&id=09ca08f7&scoped=true&"
import script from "./ReferralItem.vue?vue&type=script&lang=ts&"
export * from "./ReferralItem.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralItem.vue?vue&type=style&index=0&id=09ca08f7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca08f7",
  null
  
)

export default component.exports